<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 7861 7861"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="3930" cy="3930" r="3930"/>
  <g id="_725390456">
   <path class="fil1" d="M4706 3361c112,112 189,245 233,386 483,-155 1744,-657 1070,-1482 -1040,-1274 -958,-114 -1175,432 -93,236 -179,426 -246,565 41,30 81,62 118,99z"/>
   <path class="fil1" d="M3367 4701c-118,-118 -198,-258 -240,-407 -439,135 -1818,643 -1119,1498 1040,1274 958,114 1174,-433 100,-251 191,-449 260,-591 -26,-21 -51,-43 -75,-67z"/>
   <path class="fil1" d="M5339 4854c-231,-91 -417,-175 -556,-242 -24,31 -49,61 -77,89 -121,121 -267,202 -421,243 149,471 653,1766 1487,1085 1274,-1040 113,-958 -433,-1175z"/>
   <path class="fil1" d="M3278 3466c27,-36 56,-72 89,-105 108,-108 236,-183 372,-228 -142,-452 -648,-1796 -1495,-1105 -1274,1040 -113,958 433,1175 257,101 458,194 601,263z"/>
   <path class="fil1" d="M4467 3602c-240,-240 -629,-240 -868,0 -240,239 -240,628 0,867 239,240 628,240 868,0 239,-239 239,-628 0,-867z"/>
   <path class="fil1" d="M5937 3624c-104,10 -180,103 -170,208l65 638c10,98 92,171 188,171 7,0 13,-1 20,-1 104,-11 180,-104 169,-208l-65 -639c-10,-104 -103,-180 -207,-169z"/>
   <path class="fil1" d="M2050 3311c-104,11 -180,104 -169,208l65 639c10,97 92,170 188,170 7,0 13,0 20,-1 104,-11 180,-104 169,-208l-65 -638c-10,-105 -103,-181 -208,-170z"/>
   <path class="fil1" d="M4189 5698l-639 65c-104,10 -180,103 -169,207 10,98 92,170 188,170 7,0 13,0 20,0l638 -65c104,-11 180,-104 170,-208 -11,-104 -103,-180 -208,-169z"/>
   <path class="fil1" d="M3882 2254c6,0 13,0 19,-1l639 -65c104,-10 180,-103 169,-207 -10,-104 -103,-180 -207,-170l-639 65c-104,11 -180,104 -169,208 10,98 92,170 188,170z"/>
   <path class="fil1" d="M5462 3829c-53,6 -90,52 -85,104l52 514c5,49 46,86 94,86 4,0 7,-1 10,-1 52,-5 90,-52 85,-104l-53 -514c-5,-52 -52,-90 -103,-85z"/>
   <path class="fil1" d="M2558 3427c-52,5 -90,52 -85,104l53 514c5,49 46,86 94,86 3,0 6,-1 9,-1 53,-5 91,-52 85,-104l-52 -514c-5,-52 -51,-91 -104,-85z"/>
   <path class="fil1" d="M4092 5311l-514 52c-52,6 -90,52 -85,104 5,49 46,85 94,85 4,0 7,0 10,0l514 -52c52,-6 90,-52 85,-104 -5,-52 -51,-90 -104,-85z"/>
   <path class="fil1" d="M3989 2649c4,0 7,0 10,-1l514 -52c53,-5 90,-52 85,-104 -5,-52 -51,-89 -104,-84l-514 52c-52,5 -90,52 -85,104 5,48 46,85 94,85z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Ventilator',
};
</script>

<style scoped>
.fil0 {fill:#56D6D1}
.fil1 {fill:#FEFEFE;fill-rule:nonzero}
</style>
